<template>
  <div class="cmi-promotion-status">
    <span
      v-if="styleType == 'text'"
      class="cm-text"
    >
      {{ promoStatuses[type] }}
    </span>
    <span
      v-else
      class="cmi-promotion-status__inner"
      :class="`cmi-promotion-status__inner--${type}`"
    >
      {{ promoStatuses[type] }}
    </span>
  </div>
</template>

<script>
import { promoStatuses } from "@/config/promotions";

export default {
  name: "PromotionStatus",

  props: {
    type: {
      type: Number,
      default: 0
    },
    styleType: {
      type: String
    }
  },

  computed: {
    promoStatuses() {
      return promoStatuses;
    }
  }
}
</script>

<style lang="scss">
.cmi-promotion-status {
  &__inner {
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 15px;
    white-space: nowrap;
    &--2 {
      border: 1px solid $color_orange;
    }
    &--3 {
      background: $color_gray_b1;
      border: 1px solid $color_gray_b1;
      color: rgba($color_text, 0.6);
    }
    &--5 {
      background: $color_green_new;
      border: 1px solid $color_green_new;
      color: $color-white;
      opacity: 0.5;
    }
  }
}
</style>
